<script setup>
import {useToastStore} from "../../store/toast.module.js";
useToastStore()
</script>
<template>
    <div class="grid">
        <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 xl:col-4 xl:col-offset-4">

            <div v-if="subscriptionDetails.errorMessage" class="mb-3">
                <Message severity="error" :closable="false">
                    <div v-html="subscriptionDetails.errorMessage"></div>
                </Message>
            </div>

            <Toast>
                <template #message="slotProps">
                    <i class="pi pi-check pt-1" style="color: green;" v-if="slotProps.message.severity==='success'"></i>
                    <i class="pi pi-times-circle pt-1" style="color: #dc2626;" v-if="slotProps.message.severity==='error'"></i>
                    <div class="p-toast-message-text">
                        <span class="p-toast-summary">{{slotProps.message.summary}}</span>
                        <div class="p-toast-detail" v-html="slotProps.message.detail" />
                    </div>
                </template>
            </Toast>

            <RouterView />
        </div>
    </div>
</template>

<script>
export default {
    name: 'app',
    computed: {
        subscriptionDetails() {
            return window.subscriptionDetails || window.unsubscribeDetails || window.donationDetails || window.inviteDetails;
        }
    },
}
</script>
